 export default class formConfig {
  // 修改密码
  static configList() {
    return [
      {
        title: "密码修改",
        name: "1",
        icon: "",
        tipsList: [
          { text: "特殊字符请在_ ~ ! @ # $ ^ & . 中选择，除此之外的其他特殊符号不可用。" }
        ],
        formConfigList: [
          {
            label: "原密码：",
            value: "ymm",
            slotName: "ymm",
            type: "slot",
            required: true,
            tip: "（可输入20个字符）",
            rule: [
              {
                required: true,
                message: "请输入原密码",
                trigger: "blur"
              }
            ]
          },
          {
            label: "新密码：",
            value: "yhmm",
            slotName: "yhmm",
            type: "slot",
            tip: "（可输入20个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种！）",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入新密码",
                trigger: "blur"
              },
              {
                pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z_!@#$^&~.]+$)(?![a-z0-9]+$)(?![a-z_!@#$^&~.]+$)(?![0-9_!@#$^&~.]+$)[a-zA-Z0-9_!@#$^&~.]{8,20}$/,
                message:
                  "请至少输入8个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种"
              }
            ]
          },
          {
            label: "确认密码：",
            value: "yhmmqr",
            slotName: "yhmmqr",
            type: "slot",
            required: true,
            tip: "（可输入20个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种！）",
            rule: [
              {
                required: true,
                message: "请再次输入新密码",
                trigger: "blur"
              },
              {
                pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z_!@#$^&~.]+$)(?![a-z0-9]+$)(?![a-z_!@#$^&~.]+$)(?![0-9_!@#$^&~.]+$)[a-zA-Z0-9_!@#$^&~.]{8,20}$/,
                message:
                  "请至少输入8个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种"
              }
            ]
          },
        ]
      }
    ];
  }
}
